if (!customElements.get("products-toolbar")) {
    class ProductsToolbar extends HTMLElement {
        constructor() {
            super();
            this.init();
        }

        init() {
            this.filtersComponent = document.querySelector("facet-filters");
            this.filtersColumn = document.querySelector(
                ".main-products-grid__filters",
            );
            this.layoutSwitcher = this.querySelector(
                ".products-toolbar__layout",
            );
            this.productsGrid = document.querySelector(".main-products-grid");

            if (this.layoutSwitcher) {
                this.layoutSwitcher.addEventListener(
                    "change",
                    this.handleLayoutChange.bind(this),
                );

                // Set the layout to the layout in localstorage
                const layout = theme.storageUtil.get("products-layout");
                if (layout && layout === "list") {
                    const toggle = document.getElementById(
                        `${layout}-layout-opt`,
                    );
                    if (toggle) toggle.click();
                    this.handleLayoutChange(null, layout);
                }
            }
        }

        /**
         * Handles 'change' events on the layout switcher buttons.
         * @param {object} evt - Event object.
         * @param {string} layout - 'grid' or 'list' - the layout to change to.
         */
        handleLayoutChange(evt, layout) {
            this.productsGrid.dataset.layout = layout || evt.target.value;
            if (!layout)
                theme.storageUtil.set("products-layout", evt.target.value);
        }
    }

    customElements.define("products-toolbar", ProductsToolbar);
}
